import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { TabletIdentifierService } from '@app-services/tablet-identifier/tablet-identifier.service'
import { TabletsService } from '@app-services/tablets/tablets.service'
import { TabletStatusEnum } from '../generated/graphql'

export const isNotConfiguredGuard: CanActivateFn = async () => {
    const tabletsService = inject(TabletsService)
    const tabletIdentifierService = inject(TabletIdentifierService)

    const identifier = tabletIdentifierService.getIdentifier()

    if (! identifier) {
        return true
    }

    const status = await tabletsService.getTabletStatus(identifier)


    return status === TabletStatusEnum.Unregistered
}
